var _path, _path2, _ellipse, _path3, _path4, _ellipse2, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5279C0 11.4514 1.68334 9.76807 3.75985 9.76807V9.76807C5.83636 9.76807 7.51971 11.4514 7.51971 13.5279V13.9016C7.51971 14.5083 7.02793 15 6.4213 15H1.09841C0.491776 15 0 14.5083 0 13.9016V13.5279Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67098 10.3963C1.62903 10.3623 2.42197 9.98047 2.5065 9.98047V11.4485H5.02839V9.98047C5.11292 9.98047 5.90586 10.3623 5.86391 10.3963V11.4624C6.23564 11.5325 6.51684 11.8589 6.51684 12.251V13.6209H1.08594V12.251C1.08594 11.8831 1.33343 11.5731 1.67098 11.4783V10.3963Z",
    fill: "#F1F1F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.76068,
    cy: 7.9754,
    rx: 2.08881,
    ry: 2.17999,
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4043 13.5279C12.4043 11.4514 14.0876 9.76807 16.1641 9.76807V9.76807C18.2406 9.76807 19.924 11.4514 19.924 13.5279V13.9016C19.924 14.5082 19.4322 15 18.8255 15H13.5027C12.8961 15 12.4043 14.5082 12.4043 13.9016V13.5279Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0753 10.3963C14.0333 10.3623 14.8263 9.98047 14.9108 9.98047V11.4485H17.4327V9.98047C17.5172 9.98047 18.3101 10.3623 18.2682 10.3963V11.4624C18.6399 11.5325 18.9211 11.8589 18.9211 12.251V13.6208H13.4902V12.251C13.4902 11.8831 13.7377 11.5731 14.0753 11.4783V10.3963Z",
    fill: "#F1F1F1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.165,
    cy: 7.97539,
    rx: 2.08879,
    ry: 2.17998,
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.79693,
    cy: 7.16216,
    r: 3.16216,
    fill: "#888888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.0676C4 11.8658 6.59554 9.27026 9.7973 9.27026V9.27026C12.9991 9.27026 15.5946 11.8658 15.5946 15.0676V17H4V15.0676Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.13b28911e0e6901932d71cb57c46f04a.svg";
export { ForwardRef as ReactComponent };